import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDDialogTitle } from '@facet-wealth/design';
import {
  RichTextAlertDescription,
} from 'Views/Page/Content/Modal/Layouts/JobBasicInformationStep/Layout/RichTextAlertDescription';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';

export default buildFacetDesignOverride()
  .nameOverride('title', { _component: () => FDDialogTitle }, overrideReadOnly)
  .nameOverride('espMatchesDescription', {
    _component: () => Richtext,
    _customProps: { Component: RichTextAlertDescription },
  }, overrideReadOnly);
